import { createContext } from "react";

const UsersNotificationsContext = createContext();

export default UsersNotificationsContext;
